import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "block",
  style: {"min-width":"4rem"}
}
const _hoisted_2 = { class: "flex items-center justify-center mb-0.5" }
const _hoisted_3 = { class: "flex items-center justify-center" }
const _hoisted_4 = { class: "font-semibold text-xs" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_svg_icon = _resolveComponent("base-svg-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_base_svg_icon, {
        class: "w-6",
        path: _ctx.path
      }, null, 8, ["path"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.text), 1)
    ])
  ]))
}